import { supabase } from './supabase'
import { formatLocalDate } from '../utils/timeSlots'

// Fetch booked time slots for a specific date using secure database function
export async function getBookedTimeSlots(date) {
  if (!date) return { data: [], error: null }

  // Format date as YYYY-MM-DD in local timezone
  const dateString = date instanceof Date
    ? formatLocalDate(date)
    : date

  console.log('Checking slot availability for date:', dateString)

  // Call the secure database function
  const { data, error } = await supabase
    .rpc('get_booked_slots', { check_date: dateString })

  if (error) {
    console.error('Error fetching booked slots:', error)
    return { data: [], error }
  }

  console.log(`Found ${data.length} booked time slots for ${dateString}:`, data)

  // Transform the data to match expected format (array of objects with preferred_time)
  // The function returns { preferred_time, slot_count } but we just need preferred_time
  const transformedData = data.map(slot => ({
    preferred_time: slot.preferred_time,
    status: 'pending' // Not returned by function but not needed for filtering
  }))

  return { data: transformedData, error: null }
}

// Fetch an appointment by its amendment token
export async function getAppointmentByToken(token) {
  if (!token) return { data: null, error: { message: 'No token provided' } }

  const { data, error } = await supabase
    .rpc('get_appointment_by_token', { p_token: token })

  if (error) {
    console.error('Error fetching appointment by token:', error)
    return { data: null, error }
  }

  // RPC returns an array; we expect a single row
  return { data: data?.[0] || null, error: null }
}

// Amend an appointment by its amendment token
export async function amendAppointment(token, { preferredDate, preferredTime, service }) {
  const dateString = preferredDate instanceof Date
    ? formatLocalDate(preferredDate)
    : preferredDate

  const { data, error } = await supabase
    .rpc('amend_appointment', {
      p_token: token,
      p_preferred_date: dateString,
      p_preferred_time: preferredTime,
      p_service: service,
    })

  if (error) {
    console.error('Error amending appointment:', error)
    return { data: null, error }
  }

  return { data, error: null }
}

// Cancel an appointment by its amendment token
export async function cancelAppointment(token) {
  if (!token) return { data: null, error: { message: 'No token provided' } }

  const { data, error } = await supabase
    .rpc('cancel_appointment', { p_token: token })

  if (error) {
    console.error('Error cancelling appointment:', error)
    return { data: null, error }
  }

  return { data, error: null }
}
